var _style, _rect, _g, _g2, _polygon, _defs, _path, _g3, _g4, _defs2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoVarun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 102.22",
    style: {
      enableBackground: "new 0 0 250 102.22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:url(#SVGID_00000112619318067753845680000015990304833232506242_);}\r\n\t.st3{fill:url(#SVGID_00000132796039244583646230000005525017251181685649_);}\r\n\t.st4{fill:url(#SVGID_00000111192055115269736890000011155873491548079781_);}\r\n\t.st5{fill:url(#SVGID_00000074405466529127774690000002017789705508451754_);}\r\n\t.st6{filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st7{fill:url(#SVGID_00000176035854076778658130000010540311147057345931_);}\r\n\t.st8{mask:url(#SVGID_00000098213934894205976400000018382007706165359801_);fill:#FCD192;}\r\n\t.st9{fill:#606060;}\r\n\t\r\n\t\t.st10{clip-path:url(#SVGID_00000119800719263053667440000007716045787556344204_);fill:none;stroke:#FFFFFF;stroke-width:4;stroke-miterlimit:10;}\r\n\t.st11{fill:url(#SVGID_00000134955720721223160360000003164656662085380751_);}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -7725.36,
    y: 66.6,
    className: "st0",
    width: 503.05,
    height: 503.05
  })), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M113.02,71.44c0,1.6-0.21,3.13-0.62,4.61s-1,2.86-1.75,4.14c-0.76,1.28-1.66,2.45-2.71,3.51s-2.22,1.96-3.51,2.72 s-2.67,1.34-4.15,1.75s-3.01,0.62-4.61,0.62H85.22V54.1h10.45c1.6,0,3.13,0.21,4.61,0.62s2.86,1,4.15,1.75 c1.29,0.76,2.46,1.67,3.51,2.72s1.95,2.23,2.71,3.51s1.34,2.66,1.75,4.14C112.81,68.31,113.02,69.85,113.02,71.44z M106.07,71.44 c0-1.44-0.27-2.78-0.81-4.04s-1.28-2.36-2.23-3.3s-2.05-1.69-3.31-2.24c-1.27-0.55-2.62-0.82-4.05-0.82h-3.46v20.81h3.46 c1.43,0,2.79-0.27,4.05-0.81s2.37-1.28,3.31-2.23c0.94-0.94,1.69-2.05,2.23-3.32C105.8,74.23,106.07,72.88,106.07,71.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.7,55.84c0,0.61-0.12,1.19-0.35,1.72c-0.23,0.53-0.55,1-0.96,1.39s-0.88,0.71-1.42,0.94s-1.12,0.35-1.73,0.35 s-1.19-0.12-1.73-0.35s-1.01-0.55-1.4-0.94s-0.71-0.86-0.94-1.39s-0.35-1.1-0.35-1.72c0-0.6,0.12-1.17,0.35-1.71 c0.23-0.54,0.55-1.01,0.94-1.4s0.86-0.71,1.4-0.94s1.12-0.35,1.73-0.35s1.19,0.12,1.73,0.35s1.01,0.55,1.42,0.94 s0.72,0.86,0.96,1.4C124.59,54.67,124.7,55.24,124.7,55.84z M123.57,88.79h-6.65V62.88h6.65V88.79z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.69,85.52c0,1.82-0.35,3.53-1.04,5.13s-1.64,2.99-2.84,4.19c-1.2,1.19-2.6,2.14-4.21,2.83s-3.32,1.04-5.14,1.04 l-3.31-0.05v-6.6l3.27,0.05c1.03,0,1.91-0.13,2.64-0.4c0.73-0.27,1.34-0.63,1.84-1.09s0.9-0.99,1.2-1.58 c0.3-0.6,0.54-1.23,0.71-1.89c-0.26,0.42-0.63,0.76-1.11,1.03s-1.02,0.48-1.61,0.65s-1.2,0.29-1.84,0.35s-1.23,0.1-1.78,0.1 c-1.82,0-3.54-0.31-5.14-0.94c-1.6-0.63-3.01-1.53-4.21-2.7c-1.2-1.17-2.15-2.6-2.84-4.29s-1.04-3.61-1.04-5.73 c0-1.95,0.35-3.77,1.04-5.44c0.69-1.68,1.64-3.13,2.84-4.36s2.6-2.18,4.21-2.88c1.61-0.69,3.32-1.04,5.14-1.04 c0.84,0,1.67,0.11,2.49,0.31c0.82,0.21,1.62,0.5,2.39,0.87s1.51,0.81,2.21,1.31c0.7,0.5,1.36,1.04,1.97,1.62l2.56-3.07h1.6 L153.69,85.52L153.69,85.52z M147.03,75.61c0-0.9-0.17-1.78-0.52-2.62s-0.82-1.6-1.42-2.25c-0.6-0.65-1.29-1.18-2.09-1.57 c-0.8-0.4-1.65-0.59-2.55-0.59s-1.75,0.15-2.55,0.46s-1.49,0.76-2.08,1.36s-1.05,1.33-1.39,2.21s-0.51,1.88-0.51,3.01 c0,1.08,0.17,2.05,0.51,2.92c0.34,0.86,0.8,1.6,1.39,2.21s1.28,1.08,2.08,1.42c0.8,0.33,1.65,0.5,2.55,0.5s1.75-0.2,2.55-0.59 s1.5-0.92,2.09-1.57c0.6-0.65,1.07-1.4,1.42-2.25S147.03,76.51,147.03,75.61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.51,55.84c0,0.61-0.12,1.19-0.35,1.72c-0.23,0.53-0.55,1-0.96,1.39s-0.88,0.71-1.42,0.94s-1.12,0.35-1.73,0.35 s-1.19-0.12-1.73-0.35s-1.01-0.55-1.4-0.94s-0.71-0.86-0.94-1.39s-0.35-1.1-0.35-1.72c0-0.6,0.12-1.17,0.35-1.71 c0.23-0.54,0.55-1.01,0.94-1.4s0.86-0.71,1.4-0.94s1.12-0.35,1.73-0.35s1.19,0.12,1.73,0.35s1.01,0.55,1.42,0.94 s0.72,0.86,0.96,1.4C166.39,54.67,166.51,55.24,166.51,55.84z M165.37,88.79h-6.65V62.88h6.65V88.79z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.4,88.79c-1.6,0-3.1-0.3-4.5-0.91s-2.63-1.44-3.69-2.49c-1.06-1.06-1.89-2.29-2.49-3.69s-0.91-2.9-0.91-4.5v-7.69 h-3.22v-6.58h3.22V52.57h6.58v10.35h10.02v6.58h-10.02v7.69c0,0.69,0.13,1.34,0.39,1.95s0.61,1.13,1.07,1.58 c0.45,0.45,0.98,0.81,1.6,1.08c0.61,0.27,1.27,0.4,1.96,0.4h5.01v6.58L183.4,88.79L183.4,88.79z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.2,88.79h-1.6l-2.56-3.56c-0.63,0.56-1.29,1.09-2,1.58c-0.7,0.49-1.44,0.92-2.21,1.28s-1.57,0.65-2.38,0.86 s-1.64,0.31-2.48,0.31c-1.82,0-3.54-0.31-5.14-0.92s-3.01-1.5-4.21-2.67c-1.2-1.17-2.15-2.6-2.84-4.29s-1.04-3.62-1.04-5.78 c0-2.02,0.35-3.87,1.04-5.55c0.69-1.68,1.64-3.13,2.84-4.34s2.6-2.15,4.21-2.82s3.32-1,5.14-1c0.84,0,1.67,0.11,2.49,0.31 c0.82,0.21,1.62,0.5,2.39,0.87s1.51,0.81,2.21,1.31c0.7,0.5,1.36,1.04,1.97,1.62l2.56-3.07h1.6L217.2,88.79L217.2,88.79z  M210.54,75.61c0-0.9-0.17-1.78-0.52-2.62s-0.82-1.6-1.42-2.25c-0.6-0.65-1.29-1.18-2.09-1.57c-0.8-0.4-1.65-0.59-2.55-0.59 s-1.75,0.15-2.55,0.46s-1.49,0.76-2.08,1.36s-1.05,1.33-1.39,2.21s-0.51,1.88-0.51,3.01s0.17,2.13,0.51,3.01 c0.34,0.88,0.8,1.62,1.39,2.21c0.59,0.6,1.28,1.05,2.08,1.36s1.65,0.46,2.55,0.46s1.75-0.2,2.55-0.59s1.5-0.92,2.09-1.57 c0.6-0.65,1.07-1.4,1.42-2.25S210.54,76.51,210.54,75.61z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.88,88.79h-6.65V52.57h6.65V88.79z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M142.88,6.39l-11.4,34.69h-6.94L113.2,6.39h7.89L128,29.54l6.94-23.15C134.94,6.39,142.88,6.39,142.88,6.39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.36,41.08h-1.6l-2.56-3.56c-0.63,0.56-1.29,1.09-2,1.58c-0.7,0.49-1.44,0.92-2.21,1.28s-1.57,0.65-2.38,0.86 s-1.64,0.31-2.48,0.31c-1.82,0-3.54-0.31-5.14-0.92c-1.6-0.61-3.01-1.5-4.21-2.67c-1.2-1.17-2.15-2.6-2.84-4.29 c-0.69-1.69-1.04-3.62-1.04-5.78c0-2.02,0.35-3.87,1.04-5.55c0.69-1.69,1.64-3.13,2.84-4.34s2.6-2.15,4.21-2.82s3.32-1,5.14-1 c0.84,0,1.67,0.1,2.49,0.31s1.62,0.5,2.39,0.87s1.51,0.81,2.21,1.31c0.7,0.5,1.36,1.04,1.97,1.62l2.56-3.07h1.6L168.36,41.08 L168.36,41.08z M161.71,27.89c0-0.9-0.17-1.78-0.52-2.62s-0.82-1.6-1.42-2.25c-0.6-0.65-1.29-1.18-2.09-1.57 c-0.8-0.4-1.65-0.59-2.55-0.59s-1.75,0.15-2.55,0.46s-1.49,0.76-2.08,1.35c-0.59,0.6-1.05,1.33-1.39,2.21 c-0.34,0.88-0.51,1.88-0.51,3.01s0.17,2.13,0.51,3.01c0.34,0.88,0.8,1.62,1.39,2.21c0.59,0.6,1.28,1.05,2.08,1.35 c0.8,0.31,1.65,0.46,2.55,0.46s1.75-0.2,2.55-0.59c0.8-0.4,1.5-0.92,2.09-1.57c0.6-0.65,1.07-1.4,1.42-2.25 S161.71,28.8,161.71,27.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,41.08h-6.6V15.17h1.6l2.18,3.07c1.06-0.97,2.27-1.71,3.63-2.24c1.36-0.52,2.76-0.79,4.21-0.79h5.83v6.58H185 c-0.69,0-1.35,0.13-1.96,0.39s-1.14,0.61-1.6,1.06c-0.45,0.45-0.81,0.98-1.06,1.6c-0.26,0.61-0.39,1.27-0.39,1.96v14.28H180z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.75,38.06c-0.53,0.48-1.1,0.94-1.71,1.37c-0.6,0.43-1.24,0.8-1.9,1.11c-0.66,0.31-1.34,0.56-2.04,0.75 s-1.42,0.28-2.14,0.28c-1.6,0-3.1-0.28-4.5-0.85c-1.4-0.56-2.63-1.37-3.69-2.41s-1.89-2.31-2.49-3.8 c-0.61-1.49-0.91-3.17-0.91-5.02V15.17h6.58v14.32c0,0.87,0.13,1.65,0.4,2.33c0.27,0.69,0.62,1.26,1.08,1.73 c0.45,0.47,0.98,0.82,1.58,1.06c0.61,0.24,1.25,0.36,1.95,0.36c0.68,0,1.32-0.16,1.92-0.47c0.61-0.31,1.13-0.73,1.58-1.25 s0.81-1.1,1.06-1.75c0.26-0.65,0.39-1.33,0.39-2.02V15.17h6.61v25.91h-1.6L212.75,38.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.16,41.08h-6.6V15.17h1.6l2.18,2.52c1.06-0.97,2.27-1.71,3.62-2.24c1.35-0.52,2.75-0.79,4.22-0.79 c1.58,0,3.07,0.3,4.48,0.91c1.4,0.6,2.63,1.44,3.68,2.49c1.05,1.06,1.88,2.29,2.48,3.7c0.6,1.41,0.91,2.92,0.91,4.51v14.81h-6.61 V26.27c0-0.68-0.13-1.32-0.39-1.92s-0.61-1.13-1.06-1.58s-0.98-0.81-1.57-1.06s-1.23-0.39-1.91-0.39c-0.69,0-1.35,0.13-1.96,0.39 s-1.14,0.61-1.6,1.06c-0.45,0.45-0.81,0.98-1.06,1.58s-0.39,1.25-0.39,1.92v14.81H228.16z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.1562,
    y1: 111.8661,
    x2: 27.8275,
    y2: 50.3627,
    gradientTransform: "matrix(1 0 0 -1 0 104)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0497,
    style: {
      stopColor: "#18EAF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8799,
    style: {
      stopColor: "#002223"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "25.97,1.21 1.26,1.2 25.09,42.52  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145759078389125754510000005792422946951249303_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.965,
    y1: 104.2158,
    x2: 25.7351,
    y2: 54.2021,
    gradientTransform: "matrix(1 0 0 -1 0 104)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0497,
    style: {
      stopColor: "#18EAF1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8799,
    style: {
      stopColor: "#002223"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145759078389125754510000005792422946951249303_)"
    },
    d: "M1.26,1.2c0,0,19.87,8.07,26.18,25.19 s-2.35,17.87-2.35,17.87L1.76,2.06L1.26,1.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080176382463782899440000011516181694541316287_",
    gradientUnits: "userSpaceOnUse",
    x1: -13.3432,
    y1: 114.4134,
    x2: 54.4721,
    y2: 47.6618,
    gradientTransform: "matrix(1 0 0 -1 0 104)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3822,
    style: {
      stopColor: "#662D91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5488,
    style: {
      stopColor: "#862882"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DA1C5C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080176382463782899440000011516181694541316287_)"
    },
    d: "M25.09,60.5c1.5,0,3,0.01,4.5,0.01 c3.38,0.01,6.75,0.01,10.13,0.02c4.65,0,9.31,0.02,13.96,0.03c0.96,0,1.93,0.07,2.89,0.01c1.9-0.13,3.9-0.62,5.72-1 c1.8-0.38,3.58-1.11,5.12-2.14c0,0,0.09-0.06,0.08-0.06L40.03,9.97c-1.47-2.53-3.5-4.7-5.99-6.23c-2.3-1.4-5.35-2.63-8.96-2.54 L25.09,60.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115483198104459303320000003665012775690548128_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.9891,
    y1: 51.1713,
    x2: 35.6101,
    y2: 83.6765,
    gradientTransform: "matrix(1 0 0 -1 0 104)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000115483198104459303320000003665012775690548128_)"
    },
    points: "25.97,12.22 41.46,12.22  67.58,57.49 67.38,57.63 66.78,58 66.13,58.35 65.33,58.73 64.37,59.12 63.13,59.51 60.69,60.05 58.5,60.47 57.2,60.64  56.26,60.71 55.45,60.71 53.95,60.68  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070798074155234549790000000523926209723678373_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.8776,
    y1: 10.7941,
    x2: 143.0122,
    y2: 155.4668,
    gradientTransform: "matrix(1 0 0 -1 0 104)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCE4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1369,
    style: {
      stopColor: "#FECA4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3655,
    style: {
      stopColor: "#E37750"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6229,
    style: {
      stopColor: "#C31656"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8743,
    style: {
      stopColor: "#C31656"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070798074155234549790000000523926209723678373_)"
    },
    d: "M107.26,1.42 C90.22,30.8,73.18,60.19,56.14,89.58c-0.73,1.27-1.47,2.53-2.2,3.8L43.75,75.55v-0.06h-0.04l-6.28-10.98l-2.32-3.99 c2.98,0,6,0.02,8.98,0.02c2.55,0,5.11,0,7.66,0c3.24,0,6.53,0.01,9.68-0.8c2.61-0.66,5.13-1.79,7.44-3.16 c4.55-2.7,8.47-6.56,11.04-11.2c1.43-2.59,2.43-5.43,2.83-8.36c1.19-8.66-1.33-17.8-7.3-24.26c-5.4-5.85-13.37-9.25-21.34-9.1 c0.01-0.72,0.03-1.43,0.04-2.15C71.84,1.48,89.55,1.45,107.26,1.42z"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 46.92,
    y: 52.1,
    width: 30.95,
    height: 41.35
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 46.92,
    y: 52.1,
    width: 30.95,
    height: 41.35,
    id: "SVGID_00000098213934894205976400000018382007706165359801_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027562139610942875200000000123079484474110341_",
    gradientUnits: "userSpaceOnUse",
    x1: -7673.6899,
    y1: -482.8969,
    x2: -7649.106,
    y2: -421.1198,
    gradientTransform: "matrix(1 0 0 -1 7719.8457 -372.3764)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 44.52,
    y: 42.5,
    style: {
      fill: "url(#SVGID_00000027562139610942875200000000123079484474110341_)"
    },
    width: 35.82,
    height: 54.25
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M46.92,81.1c0,0,15.82-2.92,28.21-24.28S53.9,93.45,53.9,93.45l-2.54-4.52l-4.06-7.14L46.92,81.1L46.92,81.1z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M89.93,93.48l-2.27,3.27l-0.31,1.75h-1.01l0.32-1.75l-1.13-3.27h1.14l0.67,2.28l1.47-2.28H89.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M90.89,98.35c-0.26-0.14-0.46-0.34-0.61-0.59s-0.22-0.55-0.22-0.88c0-0.45,0.11-0.86,0.32-1.23 s0.51-0.67,0.88-0.88c0.37-0.22,0.79-0.32,1.24-0.32c0.34,0,0.64,0.07,0.91,0.21c0.27,0.14,0.47,0.34,0.62,0.59 s0.22,0.55,0.22,0.88c0,0.46-0.11,0.87-0.32,1.24s-0.51,0.66-0.89,0.87s-0.79,0.32-1.25,0.32C91.46,98.56,91.15,98.49,90.89,98.35 z M92.59,97.49c0.2-0.14,0.35-0.32,0.46-0.55s0.17-0.47,0.17-0.73c0-0.29-0.08-0.51-0.24-0.67c-0.16-0.16-0.36-0.23-0.61-0.23 c-0.24,0-0.46,0.07-0.65,0.21s-0.34,0.33-0.44,0.56s-0.16,0.48-0.16,0.74c0,0.28,0.08,0.5,0.23,0.65s0.35,0.23,0.59,0.23 C92.17,97.7,92.39,97.63,92.59,97.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M99.46,94.51l-0.7,3.98h-1.01l0.09-0.5c-0.15,0.17-0.34,0.31-0.57,0.41c-0.23,0.1-0.46,0.15-0.71,0.15 c-0.41,0-0.74-0.11-0.98-0.33c-0.24-0.22-0.36-0.54-0.36-0.95c0-0.15,0.01-0.29,0.04-0.41l0.41-2.34h1.01l-0.39,2.19 c-0.01,0.09-0.02,0.17-0.02,0.25c0,0.24,0.07,0.42,0.19,0.54c0.13,0.13,0.31,0.19,0.55,0.19c0.27,0,0.51-0.08,0.7-0.25 s0.31-0.41,0.37-0.73l0.39-2.19h0.99V94.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M102.35,94.66c0.23-0.13,0.48-0.2,0.75-0.2l-0.19,1.06h-0.27c-0.3,0-0.54,0.06-0.72,0.19 c-0.18,0.13-0.31,0.35-0.39,0.66l-0.37,2.13h-1.01l0.71-3.98h1.01l-0.12,0.71C101.91,94.98,102.12,94.79,102.35,94.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M109.72,95.79c-0.17,0.23-0.4,0.42-0.69,0.57c-0.29,0.14-0.65,0.22-1.06,0.22h-0.84l-0.34,1.93h-1.01 l0.89-5.02h1.85c0.51,0,0.9,0.11,1.17,0.34c0.26,0.23,0.4,0.53,0.4,0.91c0,0.11-0.01,0.21-0.03,0.3 C109.99,95.3,109.88,95.55,109.72,95.79z M108.71,95.58c0.16-0.13,0.26-0.32,0.3-0.55c0.01-0.04,0.01-0.1,0.01-0.19 c0-0.38-0.23-0.57-0.71-0.57h-0.79l-0.27,1.5h0.8C108.33,95.78,108.55,95.71,108.71,95.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M111.06,95.42c0.21-0.31,0.47-0.55,0.78-0.72s0.63-0.25,0.97-0.25c0.3,0,0.55,0.06,0.75,0.18 s0.35,0.27,0.45,0.45l0.1-0.57h1.01l-0.71,3.98h-1.01l0.11-0.58c-0.16,0.19-0.36,0.34-0.61,0.46s-0.53,0.18-0.82,0.18 s-0.55-0.07-0.78-0.2s-0.4-0.32-0.52-0.56c-0.12-0.24-0.19-0.52-0.19-0.84c0-0.15,0.01-0.3,0.04-0.47 C110.71,96.09,110.85,95.73,111.06,95.42z M113.79,96.23c0-0.28-0.08-0.5-0.25-0.66s-0.37-0.24-0.62-0.24 c-0.19,0-0.37,0.04-0.54,0.14c-0.17,0.09-0.33,0.22-0.46,0.4s-0.21,0.38-0.26,0.62c-0.01,0.09-0.02,0.18-0.02,0.26 c0,0.29,0.08,0.51,0.25,0.68c0.16,0.17,0.37,0.25,0.62,0.25c0.19,0,0.37-0.05,0.55-0.14s0.33-0.23,0.46-0.41s0.21-0.39,0.26-0.63 C113.78,96.38,113.79,96.29,113.79,96.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M118.01,94.66c0.23-0.13,0.48-0.2,0.75-0.2l-0.19,1.06h-0.27c-0.3,0-0.54,0.06-0.72,0.19 c-0.18,0.13-0.31,0.35-0.39,0.66l-0.37,2.13h-1.01l0.71-3.98h1.01l-0.12,0.71C117.58,94.98,117.78,94.79,118.01,94.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M120.5,97.27c0,0.03-0.01,0.07-0.01,0.12c0,0.1,0.03,0.16,0.08,0.2c0.06,0.04,0.15,0.06,0.28,0.06h0.47 l-0.15,0.85h-0.64c-0.72,0-1.08-0.3-1.08-0.9c0-0.11,0.01-0.23,0.03-0.34l0.34-1.92h-0.47l0.14-0.83h0.48l0.17-0.99h1.01 l-0.17,0.99h0.88l-0.14,0.83h-0.89L120.5,97.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M126.19,94.79c0.24,0.22,0.36,0.54,0.36,0.95c0,0.15-0.01,0.29-0.04,0.42l-0.42,2.34h-1l0.39-2.2 c0.01-0.09,0.02-0.17,0.02-0.25c0-0.24-0.06-0.42-0.19-0.55c-0.13-0.12-0.31-0.19-0.54-0.19c-0.27,0-0.5,0.08-0.69,0.24 c-0.19,0.16-0.32,0.39-0.38,0.69l-0.4,2.25h-1.01l0.71-3.98h1.01L123.93,95c0.16-0.17,0.36-0.3,0.58-0.4 c0.23-0.1,0.46-0.15,0.71-0.15C125.63,94.46,125.95,94.57,126.19,94.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M131.11,94.87c0.3,0.28,0.45,0.66,0.45,1.13c0,0.15-0.01,0.29-0.04,0.41c-0.03,0.14-0.06,0.27-0.09,0.37 h-2.91c0,0.03-0.01,0.08-0.01,0.14c0,0.25,0.07,0.44,0.22,0.59c0.15,0.14,0.34,0.21,0.58,0.21c0.2,0,0.38-0.04,0.52-0.13 c0.15-0.09,0.27-0.21,0.36-0.35h1.09c-0.18,0.38-0.45,0.7-0.82,0.95c-0.37,0.25-0.79,0.37-1.26,0.37c-0.51,0-0.92-0.14-1.22-0.43 c-0.31-0.29-0.46-0.68-0.46-1.17c0-0.14,0.01-0.29,0.04-0.45c0.07-0.41,0.22-0.77,0.44-1.09s0.5-0.55,0.83-0.72 s0.69-0.25,1.09-0.25C130.41,94.45,130.81,94.59,131.11,94.87z M130.54,96.01c0-0.23-0.07-0.41-0.22-0.54s-0.34-0.19-0.58-0.19 c-0.25,0-0.48,0.08-0.68,0.24c-0.2,0.16-0.34,0.38-0.42,0.66h1.9C130.53,96.1,130.54,96.04,130.54,96.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M134.48,94.66c0.23-0.13,0.48-0.2,0.75-0.2l-0.19,1.06h-0.27c-0.3,0-0.54,0.06-0.72,0.19 c-0.18,0.13-0.31,0.35-0.39,0.66l-0.37,2.13h-1.01l0.71-3.98H134l-0.12,0.71C134.04,94.98,134.25,94.79,134.48,94.66z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M155.84,94.51l-0.7,3.98h-1.01l0.71-3.98H155.84z M155.04,93.9c-0.1-0.09-0.14-0.21-0.14-0.34 c0-0.19,0.07-0.36,0.22-0.49s0.32-0.21,0.51-0.21c0.15,0,0.28,0.05,0.37,0.14c0.1,0.09,0.14,0.21,0.14,0.35 c0,0.19-0.07,0.36-0.22,0.49s-0.31,0.21-0.51,0.21C155.27,94.04,155.14,93.99,155.04,93.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M160.41,94.79c0.24,0.22,0.36,0.54,0.36,0.95c0,0.15-0.01,0.29-0.04,0.42l-0.42,2.34h-1l0.39-2.2 c0.01-0.09,0.02-0.17,0.02-0.25c0-0.24-0.06-0.42-0.19-0.55c-0.13-0.12-0.31-0.19-0.54-0.19c-0.27,0-0.5,0.08-0.69,0.24 c-0.19,0.16-0.32,0.39-0.38,0.69l-0.4,2.25h-1.01l0.71-3.98h1.01L158.15,95c0.16-0.17,0.36-0.3,0.58-0.4 c0.23-0.1,0.46-0.15,0.71-0.15C159.85,94.46,160.17,94.57,160.41,94.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M167.84,93.72c0.34,0.16,0.6,0.39,0.78,0.69s0.27,0.65,0.27,1.06c0,0.18-0.02,0.36-0.05,0.53 c-0.09,0.5-0.27,0.94-0.56,1.32s-0.65,0.67-1.08,0.87c-0.44,0.21-0.92,0.31-1.45,0.31H164l0.89-5.02h1.75 C167.1,93.48,167.5,93.56,167.84,93.72z M167.16,97.23c0.34-0.3,0.55-0.71,0.65-1.24c0.02-0.16,0.04-0.29,0.04-0.41 c0-0.4-0.12-0.71-0.36-0.93s-0.58-0.33-1.04-0.33h-0.71l-0.59,3.36h0.71C166.39,97.68,166.82,97.53,167.16,97.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M171.26,94.51l-0.7,3.98h-1.01l0.71-3.98H171.26z M170.46,93.9c-0.1-0.09-0.14-0.21-0.14-0.34 c0-0.19,0.07-0.36,0.22-0.49s0.32-0.21,0.51-0.21c0.15,0,0.28,0.05,0.37,0.14c0.1,0.09,0.14,0.21,0.14,0.35 c0,0.19-0.07,0.36-0.22,0.49s-0.31,0.21-0.51,0.21C170.69,94.04,170.56,93.99,170.46,93.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M174.98,94.63c0.21,0.12,0.36,0.27,0.44,0.46l0.1-0.57h1.01l-0.71,4.01c-0.07,0.37-0.2,0.7-0.4,0.99 s-0.46,0.52-0.79,0.69s-0.7,0.25-1.12,0.25c-0.56,0-1-0.13-1.31-0.4c-0.31-0.26-0.46-0.62-0.43-1.08h1 c0.02,0.18,0.11,0.33,0.26,0.43c0.16,0.11,0.36,0.16,0.61,0.16c0.3,0,0.55-0.09,0.76-0.26c0.21-0.17,0.35-0.44,0.41-0.79 l0.11-0.62c-0.16,0.19-0.37,0.34-0.61,0.47c-0.25,0.12-0.52,0.19-0.81,0.19s-0.55-0.07-0.78-0.2s-0.41-0.32-0.53-0.56 S172,97.28,172,96.96c0-0.15,0.01-0.3,0.04-0.47c0.07-0.4,0.21-0.76,0.43-1.07c0.21-0.31,0.47-0.55,0.78-0.72s0.63-0.25,0.97-0.25 C174.51,94.45,174.77,94.51,174.98,94.63z M175.19,96.23c0-0.28-0.08-0.5-0.25-0.66s-0.37-0.24-0.62-0.24 c-0.19,0-0.37,0.04-0.54,0.14c-0.17,0.09-0.33,0.22-0.46,0.4s-0.21,0.38-0.26,0.62c-0.01,0.09-0.02,0.18-0.02,0.26 c0,0.29,0.08,0.51,0.25,0.68c0.16,0.17,0.37,0.25,0.62,0.25c0.19,0,0.37-0.05,0.55-0.14c0.18-0.09,0.33-0.23,0.46-0.41 s0.21-0.39,0.26-0.63C175.18,96.38,175.19,96.29,175.19,96.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M178.93,94.51l-0.7,3.98h-1.01l0.71-3.98H178.93z M178.13,93.9c-0.1-0.09-0.14-0.21-0.14-0.34 c0-0.19,0.07-0.36,0.22-0.49s0.32-0.21,0.51-0.21c0.15,0,0.28,0.05,0.37,0.14c0.1,0.09,0.14,0.21,0.14,0.35 c0,0.19-0.07,0.36-0.22,0.49s-0.31,0.21-0.51,0.21C178.35,94.04,178.22,93.99,178.13,93.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M181,97.27c0,0.03-0.01,0.07-0.01,0.12c0,0.1,0.03,0.16,0.08,0.2c0.06,0.04,0.15,0.06,0.28,0.06h0.47 l-0.15,0.85h-0.64c-0.72,0-1.08-0.3-1.08-0.9c0-0.11,0.01-0.23,0.03-0.34l0.34-1.92h-0.47l0.14-0.83h0.48l0.17-0.99h1.01 l-0.17,0.99h0.88l-0.14,0.83h-0.89L181,97.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M183.32,95.42c0.21-0.31,0.47-0.55,0.78-0.72s0.63-0.25,0.97-0.25c0.3,0,0.55,0.06,0.75,0.18 s0.35,0.27,0.45,0.45l0.1-0.57h1.01l-0.71,3.98h-1.01l0.11-0.58c-0.16,0.19-0.36,0.34-0.61,0.46s-0.53,0.18-0.82,0.18 c-0.29,0-0.55-0.07-0.78-0.2s-0.4-0.32-0.52-0.56c-0.12-0.24-0.19-0.52-0.19-0.84c0-0.15,0.01-0.3,0.04-0.47 C182.96,96.09,183.1,95.73,183.32,95.42z M186.05,96.23c0-0.28-0.08-0.5-0.25-0.66s-0.37-0.24-0.62-0.24 c-0.19,0-0.37,0.04-0.54,0.14c-0.17,0.09-0.33,0.22-0.46,0.4s-0.21,0.38-0.26,0.62c-0.01,0.09-0.02,0.18-0.02,0.26 c0,0.29,0.08,0.51,0.25,0.68c0.16,0.17,0.37,0.25,0.62,0.25c0.19,0,0.37-0.05,0.55-0.14c0.18-0.09,0.33-0.23,0.46-0.41 s0.21-0.39,0.26-0.63C186.04,96.38,186.05,96.29,186.05,96.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M190.02,93.18l-0.94,5.32h-1.01l0.94-5.32H190.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M194.54,94.26l-0.23,1.3H196l-0.14,0.78h-1.69l-0.24,1.36h1.91l-0.14,0.8h-2.92l0.89-5.03h2.91l-0.14,0.79 C196.44,94.26,194.54,94.26,194.54,94.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M199.37,96.5l0.97,2h-1.14l-0.6-1.23l-0.95,1.23h-1.08l1.65-2l-0.96-1.99h1.14l0.6,1.23l0.95-1.23h1.08 L199.37,96.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M201.82,95.42c0.22-0.31,0.49-0.55,0.82-0.72s0.68-0.25,1.07-0.25c0.49,0,0.88,0.12,1.16,0.37 c0.28,0.24,0.44,0.59,0.47,1.04h-1.09c-0.03-0.17-0.1-0.31-0.22-0.41c-0.12-0.1-0.28-0.15-0.48-0.15c-0.29,0-0.53,0.1-0.74,0.31 c-0.2,0.21-0.34,0.5-0.41,0.89c-0.02,0.13-0.04,0.25-0.04,0.35c0,0.27,0.07,0.48,0.2,0.63c0.13,0.15,0.32,0.22,0.56,0.22 c0.4,0,0.7-0.18,0.89-0.55h1.09c-0.19,0.43-0.47,0.77-0.84,1.03c-0.37,0.25-0.8,0.38-1.28,0.38c-0.5,0-0.91-0.14-1.21-0.43 s-0.45-0.67-0.45-1.16c0-0.15,0.01-0.3,0.04-0.47C201.45,96.09,201.6,95.73,201.82,95.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M209.67,94.87c0.3,0.28,0.45,0.66,0.45,1.13c0,0.15-0.01,0.29-0.04,0.41c-0.03,0.14-0.06,0.27-0.09,0.37 h-2.91c0,0.03-0.01,0.08-0.01,0.14c0,0.25,0.07,0.44,0.22,0.59c0.15,0.14,0.34,0.21,0.58,0.21c0.2,0,0.38-0.04,0.52-0.13 c0.15-0.09,0.27-0.21,0.36-0.35h1.09c-0.18,0.38-0.45,0.7-0.82,0.95c-0.37,0.25-0.79,0.37-1.26,0.37c-0.51,0-0.92-0.14-1.22-0.43 c-0.31-0.29-0.46-0.68-0.46-1.17c0-0.14,0.01-0.29,0.04-0.45c0.07-0.41,0.22-0.77,0.44-1.09s0.5-0.55,0.83-0.72 s0.69-0.25,1.09-0.25C208.97,94.45,209.37,94.59,209.67,94.87z M209.1,96.01c0-0.23-0.07-0.41-0.22-0.54s-0.34-0.19-0.58-0.19 c-0.25,0-0.48,0.08-0.68,0.24c-0.2,0.16-0.34,0.38-0.42,0.66h1.9C209.09,96.1,209.1,96.04,209.1,96.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M212.79,93.18l-0.94,5.32h-1.01l0.94-5.32H212.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M215.19,93.18l-0.94,5.32h-1.01l0.94-5.32H215.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M219.29,94.87c0.3,0.28,0.45,0.66,0.45,1.13c0,0.15-0.01,0.29-0.04,0.41c-0.03,0.14-0.06,0.27-0.09,0.37 h-2.91c0,0.03-0.01,0.08-0.01,0.14c0,0.25,0.07,0.44,0.22,0.59c0.15,0.14,0.34,0.21,0.58,0.21c0.2,0,0.38-0.04,0.52-0.13 c0.15-0.09,0.27-0.21,0.36-0.35h1.09c-0.18,0.38-0.45,0.7-0.82,0.95c-0.37,0.25-0.79,0.37-1.26,0.37c-0.51,0-0.92-0.14-1.22-0.43 c-0.31-0.29-0.46-0.68-0.46-1.17c0-0.14,0.01-0.29,0.04-0.45c0.07-0.41,0.22-0.77,0.44-1.09s0.5-0.55,0.83-0.72 s0.69-0.25,1.09-0.25C218.59,94.45,219,94.59,219.29,94.87z M218.72,96.01c0-0.23-0.07-0.41-0.22-0.54s-0.34-0.19-0.58-0.19 c-0.25,0-0.48,0.08-0.68,0.24c-0.2,0.16-0.34,0.38-0.42,0.66h1.9C218.71,96.1,218.72,96.04,218.72,96.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M224.35,94.79c0.24,0.22,0.36,0.54,0.36,0.95c0,0.15-0.01,0.29-0.04,0.42l-0.42,2.34h-1l0.39-2.2 c0.01-0.09,0.02-0.17,0.02-0.25c0-0.24-0.06-0.42-0.19-0.55c-0.13-0.12-0.31-0.19-0.54-0.19c-0.27,0-0.5,0.08-0.69,0.24 c-0.19,0.16-0.32,0.39-0.38,0.69l-0.4,2.25h-1.01l0.71-3.98h1.01L222.09,95c0.16-0.17,0.36-0.3,0.58-0.4 c0.23-0.1,0.46-0.15,0.71-0.15C223.79,94.46,224.12,94.57,224.35,94.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M226.15,95.42c0.22-0.31,0.49-0.55,0.82-0.72s0.68-0.25,1.07-0.25c0.49,0,0.88,0.12,1.16,0.37 c0.28,0.24,0.44,0.59,0.47,1.04h-1.09c-0.03-0.17-0.1-0.31-0.22-0.41c-0.12-0.1-0.28-0.15-0.48-0.15c-0.29,0-0.53,0.1-0.74,0.31 c-0.2,0.21-0.34,0.5-0.41,0.89c-0.02,0.13-0.04,0.25-0.04,0.35c0,0.27,0.07,0.48,0.2,0.63c0.13,0.15,0.32,0.22,0.56,0.22 c0.4,0,0.7-0.18,0.89-0.55h1.09c-0.19,0.43-0.47,0.77-0.84,1.03c-0.37,0.25-0.8,0.38-1.28,0.38c-0.5,0-0.91-0.14-1.21-0.43 s-0.45-0.67-0.45-1.16c0-0.15,0.01-0.3,0.04-0.47C225.78,96.09,225.93,95.73,226.15,95.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M234,94.87c0.3,0.28,0.45,0.66,0.45,1.13c0,0.15-0.01,0.29-0.04,0.41c-0.03,0.14-0.06,0.27-0.09,0.37h-2.91 c0,0.03-0.01,0.08-0.01,0.14c0,0.25,0.07,0.44,0.22,0.59c0.15,0.14,0.34,0.21,0.58,0.21c0.2,0,0.38-0.04,0.52-0.13 c0.15-0.09,0.27-0.21,0.36-0.35h1.09c-0.18,0.38-0.45,0.7-0.82,0.95c-0.37,0.25-0.79,0.37-1.26,0.37c-0.51,0-0.92-0.14-1.22-0.43 c-0.31-0.29-0.46-0.68-0.46-1.17c0-0.14,0.01-0.29,0.04-0.45c0.07-0.41,0.22-0.77,0.44-1.09s0.5-0.55,0.83-0.72 s0.69-0.25,1.09-0.25C233.3,94.45,233.7,94.59,234,94.87z M233.42,96.01c0-0.23-0.07-0.41-0.22-0.54s-0.34-0.19-0.58-0.19 c-0.25,0-0.48,0.08-0.68,0.24c-0.2,0.16-0.34,0.38-0.42,0.66h1.9C233.42,96.1,233.42,96.04,233.42,96.01z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000168088949819029492050000011053552134685105841_",
    points: "100.26,13.71 99.56,14.92 91.39,1.3  92.83,1.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000027564384655150025420000017779554519146706878_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168088949819029492050000011053552134685105841_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000027564384655150025420000017779554519146706878_)",
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    x1: 100.11,
    y1: 14.69,
    x2: 91.83,
    y2: 0.87
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085247710389431214170000010044265321545430414_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.3522,
    y1: 91.9993,
    x2: 106.7109,
    y2: 105.2396,
    gradientTransform: "matrix(1 0 0 -1 0 104)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C31656"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1143,
    style: {
      stopColor: "#C51C56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2682,
    style: {
      stopColor: "#CB2D55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4446,
    style: {
      stopColor: "#D44953"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6378,
    style: {
      stopColor: "#E17151"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8421,
    style: {
      stopColor: "#F1A24E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCE4B"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000085247710389431214170000010044265321545430414_)"
    },
    points: "100.16,13.66 92.87,1.44  107.41,1.31  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVarun);
export default __webpack_public_path__ + "static/media/logo-varun.e03a723bd40b4f197518e24b36eb75b8.svg";
export { ForwardRef as ReactComponent };